import React, { useState, useEffect, useRef } from 'react';
import { getUserId } from './utils';
import CategoryTabs from './CategoryTabs';
import TodoList from './TodoList';

function App() {
  const userId = getUserId();
  const [todoLists, setTodoLists] = useState({});
  const [activeCategory, setActiveCategory] = useState(0);
  const [categories, setCategories] = useState(() => {
    const storedCategories = JSON.parse(localStorage.getItem(userId + '_categories'));
    return storedCategories || ['カテゴリ1', 'カテゴリ2', 'カテゴリ3'];
  });
  const [editingCategoryIndex, setEditingCategoryIndex] = useState(null);

  const inputRef = useRef("");
  const inputCatRef = useRef("");

  useEffect(() => {
    // ユーザーIDに基づいてカテゴリごとのTODOリストをローカルストレージから取得
    const storedLists = JSON.parse(localStorage.getItem(userId)) || {};

    // カテゴリ名を取得
    const storedCategories = JSON.parse(localStorage.getItem(userId + '_categories')) || categories;
    
    // 各カテゴリのデータ構造を統一
    const normalizedLists = {};
    storedCategories.forEach(cat => {
      const todos = storedLists[cat] || [];
      normalizedLists[cat] = todos.map(todo => {
        if (typeof todo === 'string') {
          return { text: todo, checked: false };
        } else if (typeof todo === 'object' && todo !== null && 'text' in todo && 'checked' in todo) {
          return todo;
        } else {
          return { text: JSON.stringify(todo), checked: false };
        }
      });
    });
    setTodoLists(normalizedLists);
    setCategories(storedCategories);
    // activeCategoryが未設定または範囲外なら先頭カテゴリ
    setActiveCategory(0);
  }, []);

  // TODOを追加する関数
  const addTodo = () => {
    const newTodo = inputRef.current.value.trim();
    if (!newTodo) return;
    const categoryName = categories.find((_, index) => index === activeCategory);

    // 新しいTODOをオブジェクト形式でリストに追加
    const newTodoObj = { text: newTodo, checked: false };
    const updatedLists = { ...todoLists };
    updatedLists[categoryName] = [...(updatedLists[categoryName] || []), newTodoObj];

    // TODOリストを保存
    setTodoLists(updatedLists);
    localStorage.setItem(userId, JSON.stringify(updatedLists));

    inputRef.current.value = '';
  };

  // リストを全件削除する関数
  const resetTodoList = () => {
    const categoryName = categories[activeCategory];
    if (window.confirm(`${categoryName}のTODOリストをすべて削除しますか？`)) {
      const updatedLists = { ...todoLists };
      updatedLists[categoryName] = [];
      setTodoLists(updatedLists);
      localStorage.setItem(userId, JSON.stringify(updatedLists));
    }
  };

  // エンターキーでTODOを追加する処理
  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      addTodo();
    }
  };

  // 指定したインデックスのTODOを削除する関数
  const deleteTodo = (index) => {
    const categoryName = categories[activeCategory];
    const updatedLists = { ...todoLists };
    updatedLists[categoryName] = updatedLists[categoryName].filter((_, i) => i !== index);
    setTodoLists(updatedLists);
    localStorage.setItem(userId, JSON.stringify(updatedLists));
  };

  return (
    <div className="container">
      <h1 className="my-4">TODO List</h1>
      <div className="input-group mb-3">
        <input type="text" className="form-control" placeholder="ここに入力" ref={inputRef} onKeyPress={handleKeyPress} />
        <button className="btn btn-outline-primary" type="button" onClick={addTodo}>追加</button>
      </div>
      <CategoryTabs
        categories={categories}
        activeCategory={activeCategory}
        setActiveCategory={setActiveCategory}
        editingCategoryIndex={editingCategoryIndex}
        setEditingCategoryIndex={setEditingCategoryIndex}
        todoLists={todoLists}
        setTodoLists={setTodoLists}
        setCategories={setCategories}
        userId={userId}
        inputCatRef={inputCatRef}
      />
      <TodoList
        categories={categories}
        activeCategory={activeCategory}
        todoLists={todoLists}
        setTodoLists={setTodoLists}
        deleteTodo={deleteTodo}
      />
      <div className="text-end">
        <button
          className="btn btn-sm btn-danger"
          onClick={resetTodoList}
          disabled={!(categories[activeCategory] && todoLists[categories[activeCategory]] && todoLists[categories[activeCategory]].length > 0)}
        >
          リセット
        </button>
      </div>
    </div>
  );
}

export default App;
